import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import RequireAuth from './auth/RequireAuth';
import BoxScorePage from './pages/BoxScorePage';
import GameList from './pages/GameList';
import GameView from './pages/GameView';
import HistoricalGameList from './pages/HistoricalGameList';
import Login from './pages/Login';
import CommentsPage from './pages/CommentsPage';
import Rosters from './pages/Rosters';

export default function App(): JSX.Element {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/games"
          element={
            <RequireAuth>
              <GameList />
            </RequireAuth>
          }
        />
        <Route
          path="/games/historical"
          element={
            <RequireAuth>
              <HistoricalGameList />
            </RequireAuth>
          }
        />
        <Route
          path="/games/:gamePk"
          element={
            <RequireAuth>
              <GameView />
            </RequireAuth>
          }
        />
        <Route
          path="/games/:gamePk/rosters"
          element={
            <RequireAuth>
              <Rosters />
            </RequireAuth>
          }
        />
        <Route
          path="/games/:gamePk/boxscore"
          element={
            <RequireAuth>
              <BoxScorePage />
            </RequireAuth>
          }
        />
        <Route
          path="/comments"
          element={
            <RequireAuth>
              <CommentsPage />
            </RequireAuth>
          }
        />
        <Route path="/" element={<Navigate to="/games" replace />} />
        <Route path="*" element={<Navigate to="/games" replace />} />
      </Routes>
    </AuthProvider>
  );
}
